import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class UploadService {
    token = localStorage.getItem('token');
    options = {
        headers: new HttpHeaders({
            'Authorization': `Bearer ${this.token}`
        })
    };

    constructor(private http: HttpClient) { }

    uploadStudents(body) {
        return this.http.post<any>(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/import_students`, body);
    }

    uploadStaff(body) {
        return this.http.post<any>(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/import_users`, body, this.options);
    }

    getUploadErrors(url){
        return this.http.get<any>(url);
    }

    private _fieldData = new BehaviorSubject<Object>(null);
    fieldData = this._fieldData.asObservable();

    sendFieldData(field, count) {
        this._fieldData.next({ 'field': field, 'count': count });
    }

    getFieldData() {
        return this._fieldData;
    }

    private _fieldCorrectionProgress = new BehaviorSubject<number>(0);
    fieldCorrectionProgress = this._fieldCorrectionProgress.asObservable();

    sendfieldCorrectionProgress(progress) {
        this._fieldCorrectionProgress.next(progress);
    }

    getfieldCorrectionProgress() {
        return this._fieldCorrectionProgress;
    }

    private _uploadSectionState = new BehaviorSubject<boolean>(false);
    uploadSectionState = this._uploadSectionState.asObservable();

    setUploadSectionState(state) {
        this._uploadSectionState.next(state);
    }

    getUploadSectionState() {
        return this._uploadSectionState;
    }
}